import React from 'react';
import styled, { css, keyframes } from 'styled-components';
import { colors } from '../../../constants/colors';

const shimmer = keyframes`
  to {
    background-position:
      350% 0,
      24px 180px
  ;
  }
`;

const SlotSkeleton = styled.div.withConfig({ componentId: 'sc-1s8oie8-0' })<{ $height: number; $width: number }>`
  background-color: ${colors.borderLine};
  animation: ${shimmer} 2.5s infinite;
  border-radius: 8px;
  ${(props) => css`
    height: ${props.$height}px;
    width: ${props.$width}px;
  `}

  background-image: linear-gradient(
      100deg,
      rgba(255, 255, 255, 0),
      rgba(255, 255, 255, 0.2) 20%,
      rgba(255, 255, 255, 0.4) 40%,
      rgba(255, 255, 255, 0.6) 60%,
      rgba(255, 255, 255, 0) 80%
    ),
    linear-gradient(${colors.borderLine} 20px, transparent 0);

  background-repeat: no-repeat;
  background-size: 200px, 200px 40px;
  background-position: -150% 0, 24px 180px;
`;

type Props = {
  height: number;
  width: number;
};

const SolvSkeleton = ({ height, width }: Props) => <SlotSkeleton $height={height} $width={width} />;

export default SolvSkeleton;
